import { render, staticRenderFns } from "./LangFlag.vue?vue&type=template&id=bb7e0246&scoped=true"
import script from "./LangFlag.vue?vue&type=script&lang=js"
export * from "./LangFlag.vue?vue&type=script&lang=js"
import style0 from "./LangFlag.vue?vue&type=style&index=0&id=bb7e0246&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7e0246",
  null
  
)

export default component.exports